import React from 'react';

/**
 * Logo + brand name row used at the top of every storefront auth card.
 * Falls back to a colored monogram tile when the brand has no logo.
 */
export default function BrandHeader({ brand }) {
  if (!brand) return null;
  return (
    <div style={{ textAlign: 'center', marginBottom: 22 }}>
      {brand.logo_upload_path ? (
        <img
          src={brand.logo_upload_path}
          alt={brand.name}
          style={{ width: 56, height: 56, borderRadius: 14, objectFit: 'cover', marginBottom: 10 }}
        />
      ) : (
        <div
          style={{
            width: 56, height: 56, borderRadius: 14,
            background: brand.brand_color || '#422AFB',
            color: '#fff', display: 'inline-flex',
            alignItems: 'center', justifyContent: 'center',
            fontWeight: 700, fontSize: 20, marginBottom: 10,
          }}
        >
          {(brand.name || '?').slice(0, 1).toUpperCase()}
        </div>
      )}
      <div style={{ fontWeight: 700, fontSize: 18, color: '#0f172a' }}>{brand.name}</div>
    </div>
  );
}
